var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ta_c pt20 pb20 mt20 mb20"},[_c('p',{staticClass:"pt10"},[_vm._v("暂无数据")])])}]

export { render, staticRenderFns }